import { Component, OnDestroy, OnInit } from '@angular/core';
import { TenantService } from '@app/Services';
import { takeUntil } from 'rxjs/operators';
import { CopyConfigLog } from '../Models';
import { CopyConfigService } from '../Services';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-copy-config-logs',
    templateUrl: './copy-config-logs.component.html',
    styleUrls: ['./copy-config-logs.component.scss'],
    imports: [MatButton, MatIcon, MatTooltip, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, DatePipe]
})
export class CopyConfigLogsComponent implements OnInit, OnDestroy {
  logEntries: CopyConfigLog[] = [];
  displayedColumns: string[] = ['status', 'date', 'source', 'logs', 'markFailed'];
  private isDestroyed$: Subject<void> = new Subject();
  private tenantId: string;
  
  public constructor(
    private copyConfigService: CopyConfigService, 
    private tenantService: TenantService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.tenantId = this.tenantService.selectedTenant.TenantId;
    this.getLogs();
  }

  ngOnDestroy(): void {
    this.isDestroyed$.next();
  }

  goToLog(jobId: string) {
    this.router.navigate(['jobs', jobId]);
  }

  // Flags the log entry as failed so a retry is no longer blocked by the
  // "copy config already in progress" check. This does not stop a run that is
  // still in progress - there is no cancellation signal in the copy config
  // pipeline.
  markLogAsFailed(log: CopyConfigLog) {
    log.HasErrors = true;
    this.copyConfigService
      .updateCopyConfigLog(log)
      .pipe(takeUntil(this.isDestroyed$))
      .subscribe(result => {
        log.HasErrors = result.HasErrors;
      });
  }

  refreshLogs() {
    this.logEntries = null;
    this.getLogs();
  }

  private getLogs() {
    this.copyConfigService
      .getCopyConfigLogs(this.tenantId)
      .pipe(takeUntil(this.isDestroyed$))
      .subscribe(result => {
        this.logEntries = result;
      });
  }
}
